import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';

// Initialize Firebase
const config = {
  apiKey: 'AIzaSyAPAQjTOXuaUtQFIP54UR8SFVGWlUxDUgw',
  authDomain: 'scrapper-ed6a0.firebaseapp.com',
  databaseURL: 'https://scrapper-ed6a0.firebaseio.com',
  projectId: 'scrapper-ed6a0',
  storageBucket: 'scrapper-ed6a0.appspot.com',
  messagingSenderId: '971188955323',
};
firebase.initializeApp(config);

const db = firebase.firestore();
db.settings({ timestampsInSnapshots: true });

const providers = {
  facebook: new firebase.auth.FacebookAuthProvider(),
};

export { db };
export { firebase };
export { providers };
